(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7636],{

/***/ 24277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/BreadCrumbs/breadCrumbs.module.sass
var breadCrumbs_module = __webpack_require__(75685);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
;// CONCATENATED MODULE: ./components/BreadCrumbs/BreadCrumbs.jsx







var BreadCrumbs = function(param) {
    var routeCrumbs = param.routeCrumbs, url = param.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadCrumbs_module_default()).wrapper,
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (breadCrumbs_module_default()).overflowWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (breadCrumbs_module_default()).crumb,
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        itemProp: "name",
                        className: (0,classcat/* default */.Z)([
                            (breadCrumbs_module_default()).home,
                            (0,_define_property/* default */.Z)({}, (breadCrumbs_module_default()).homeBf, url === "black_friday"), 
                        ]),
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/bfHomePage",
                                width: 10,
                                height: 10
                            }),
                            itemProp: "item"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                name: "common/HomePage",
                                width: 16,
                                height: 16
                            }),
                            itemProp: "item"
                        })
                    })
                }),
                routeCrumbs.map(function(i, id) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: "https://schema.org/ListItem",
                        className: (breadCrumbs_module_default()).point,
                        children: url === "black_friday" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).currentBf : (breadCrumbs_module_default()).activeBf,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            itemProp: "item",
                            href: i.link,
                            className: (breadCrumbs_module_default()).crumb,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    itemProp: "name",
                                    className: id === routeCrumbs.length - 1 ? (breadCrumbs_module_default()).current : (breadCrumbs_module_default()).active,
                                    children: i.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "position",
                                    content: id + 1
                                })
                            ]
                        })
                    }, id);
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/BreadCrumbs/index.js



/***/ }),

/***/ 50874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ arrayNews; }
/* harmony export */ });
var arrayNews = [
    {
        title: "Денис Крейцберг, \xabТвой круиз\xbb – о том, как заработать на самой консервативной отрасли путешествий",
        description: "Маркетплейс круиз.онлайн агрегирует 99,5% пассажирского флота, хотя начинался как местный проект в Самаре",
        photo: "/images/news/22.jpg",
        media: "Think Travel Tech",
        link: "https://thinktraveltech.com/news/Interview/denis-kreizberg-kruiz-online",
        date: "27.05.2021"
    },
    {
        title: "Денис Крейцберг: \xabНовая мода – на круиз.онлайн\xbb",
        description: "Итоги технологичного конкурса Travel Tech Challenge: как порвать \xabбумажные шаблоны\xbb в круизной отрасли.",
        photo: "/images/news/21.jpg",
        media: "Вести Туризм",
        link: "https://travelvesti.ru/intervyu/denis-krejtsberg-novaya-moda-na-kruiz-onlajn.html",
        date: "05.06.2021"
    },
    {
        title: "\xabКешбэк\xbb повысил продажи коротких круизов",
        description: "Доля броней по программе кешбека составила 62% от всех проданных туров за время третьего этапа акции",
        photo: "/images/news/1.jpg",
        media: "ПрофиТревел",
        link: "https://profi.travel/pages/51391/details",
        date: "29.07.2021"
    },
    {
        title: "Осенние круизы: помогла ли программа кэшбэка в продажах речных путешествий на осень?",
        description: "Какие промежуточные результаты осеннего кэшбэка зафиксировала круизная отрасль,  увеличились ли спрос?",
        photo: "/images/news/2.jpg",
        media: "Travel Russian News",
        link: "https://www.trn-news.ru/analytics/103225",
        date: "13.07.2021"
    },
    {
        title: "\xabТвой Круиз\xbb — сервис бронирования речных круизов",
        description: "Подключайтесь к партнёрской программе супермаркета круизов \xabКруиз.онлайн\xbb и зарабатывайте 2,8% с заказов",
        photo: "/images/news/3.jpg",
        media: "Travelpayouts",
        link: "https://blog.travelpayouts.com/partnyorskaya-programma-tvoj-kruiz/",
        date: "27.07.2021"
    },
    {
        title: "Кешбэк удвоил продажи речных круизов",
        description: "Рынок речных круизов вырос на 25%, а спрос — почти на 50%, в том числе из-за кешбэка",
        photo: "/images/news/4.jpg",
        media: "ПрофиТревел",
        link: "https://profi.travel/news/51828/details",
        date: "29.07.2021"
    },
    {
        title: "Кешбэк повысил спрос на круизы",
        description: "Туристы меньше опасаются антиковидных ограничений на круизах, цены осенью ниже, а кешбэк подогревает спрос.",
        photo: "/images/news/5.jpg",
        media: "Российская газета",
        link: "https://rg.ru/2021/07/29/reg-szfo/keshbek-povysil-spros-na-kruizy.html",
        date: "29.07.2021"
    },
    {
        title: "Круиз за 7 миллионов рублей! Денис Крейцберг об успешных онлайн-продажах в круизной отрасли",
        description: "Туристический бизнес – отрасль, которую больше всего \xabпотрепала\xbb пандемия.",
        photo: "/images/news/6.jpg",
        media: "VC.RU",
        link: "https://vc.ru/u/735872-nataliya-popova/280579-kruiz-za-7-millionov-rubley-denis-kreycberg-ob-uspeshnyh-onlayn-prodazhah-v-kruiznoy-otrasli",
        date: "11.08.2021"
    },
    // {
    //   title: 'Все на борт: в Казани на 30% вырос спрос на речные круизы',
    //   description:
    //     'Компании фиксируют поток повторных туристов, и ожидают сохранение спроса в 2022 году',
    //   photo: '/images/news/33.jpg',
    //   media: 'РБК',
    //   link: 'https://www.cismag.news/post/%D0%B8%D0%BD%D0%B6%D0%B5%D0%BD%D0%B5%D1%80%D0%BD%D0%BE-%D1%82%D0%B5%D1%85%D0%BD%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B9-%D0%B8%D0%BD%D1%82%D0%B5%D0%BD%D1%81%D0%B8%D0%B2-startup-%D1%81%D1%82%D0%B5%D0%BF%D1%8C-%D1%81%D0%BE%D0%B1%D1%80%D0%B0%D0%BB-%D1%81%D1%82%D0%B0%D1%80%D1%82%D0%B0%D0%BF%D1%8B-%D1%81%D0%BE-%D0%B2%D1%81%D0%B5%D0%B9-%D1%80%D0%BE%D1%81%D1%81%D0%B8%D0%B8',
    //   date: '16.08.2021',
    // },
    // {
    //   title:
    //     'Инженерно-технологический интенсив «StartUp Степь» собрал стартапы со всей России',
    //   description:
    //     'В финале Техновызова защищали свои проекты изобретатели, конструкторы и предприниматели',
    //   photo: '/images/news/7.jpg',
    //   media: 'Интернет-журнал об информационных технологиях CIS',
    //   link: 'https://www.cismag.news/post/%D0%B8%D0%BD%D0%B6%D0%B5%D0%BD%D0%B5%D1%80%D0%BD%D0%BE-%D1%82%D0%B5%D1%85%D0%BD%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%87%D0%B5%D1%81%D0%BA%D0%B8%D0%B9-%D0%B8%D0%BD%D1%82%D0%B5%D0%BD%D1%81%D0%B8%D0%B2-startup-%D1%81%D1%82%D0%B5%D0%BF%D1%8C-%D1%81%D0%BE%D0%B1%D1%80%D0%B0%D0%BB-%D1%81%D1%82%D0%B0%D1%80%D1%82%D0%B0%D0%BF%D1%8B-%D1%81%D0%BE-%D0%B2%D1%81%D0%B5%D0%B9-%D1%80%D0%BE%D1%81%D1%81%D0%B8%D0%B8',
    //   date: '17.08.2021',
    // },
    {
        title: "Как ливни на Черном море и обмеление Волги повлияли на круизы",
        description: "В круизном сегменте подвели предварительные итоги лета и дали прогнозы на осень.",
        photo: "/images/news/8.jpg",
        media: "ПрофиТревел",
        link: "https://profi.travel/news/52151/details",
        date: "19.08.2021"
    },
    {
        title: "Туроператорам из-за обмеления Волги пришлось поменять график круизов",
        description: "Туроператоры на фоне растущего спроса на речные круизы столкнулись с ограничениями судоходства по Волге. ",
        photo: "/images/news/9.jpg",
        media: "Российская газета",
        link: "https://rg.ru/2021/08/20/reg-pfo/turoperatoram-iz-za-obmeleniia-volgi-prishlos-pomeniat-grafik-kruizov.html",
        date: "20.08.2021"
    },
    {
        title: "Пожилые туристы стали чаще бронировать круизные туры онлайн",
        description: "Ежегодные потери грузоотправителей из-за обмеления Волги составляют около 14 млрд р.",
        photo: "/images/news/11.jpg",
        media: "Интерфакс-Туризм",
        link: "https://tourism.interfax.ru/ru/news/articles/81343/",
        date: "24.08.2021"
    },
    {
        title: "Будет ли Волга востребованной транспортной артерией",
        description: "Как региональная компания стала самым крупным агрегатором речных круизов в России",
        photo: "/images/news/10.jpg",
        media: "Российская газета",
        link: "https://rg.ru/2021/08/30/budet-li-volga-vostrebovannoj-transportnoj-arteriej.html",
        date: "30.08.2021"
    },
    {
        title: "\xabВ родной Самаре работать намного комфортнее\xbb",
        description: "Как региональная компания стала самым крупным агрегатором речных круизов в России",
        photo: "/images/news/24.jpg",
        media: "Коммерсантъ Волга",
        link: "https://www.kommersant.ru/doc/4977799",
        date: "10.09.2021"
    },
    {
        title: "Кешбэк помог круизной отрасли Петербурга и Ленобласти довести доходы до 1 млрд",
        description: "Валовый доход круизной отрасли Петербурга и Ленобласти с января по сентябрь 2021 года составил 1 млрд р.",
        photo: "/images/news/13.jpg",
        media: "Деловой Петербург",
        link: "https://www.dp.ru/a/2021/09/15/Za_uplivajushhim_keshbjek",
        date: "16.09.2021"
    },
    {
        title: "Туристы перебрались в каюты.Внутренний рынок речных круизов растет",
        description: "Рост внутреннего туризма на фоне пандемии помог увеличить аудиторию речным круизам.",
        photo: "/images/news/12.jpg",
        media: "Коммерсантъ",
        link: "https://www.kommersant.ru/doc/4994838",
        date: "18.09.2021"
    },
    {
        title: "Куда изволите?",
        description: "Акция раннего бронирования позволяет россиянам выкупать желаемый рейс и каюту заранее, со скидками до 30%.",
        photo: "/images/news/31.jpg",
        media: "Вести-Туризм",
        link: "https://travelvesti.ru/news/kuda-izvolite.html",
        date: "21.09.2021"
    },
    {
        title: "КРУПНЕЙШИЙ РОССИЙСКИЙ ИНТЕРНЕТ-МАГАЗИН КРУИЗОВ МЕНЯЕТ РЫНОК И БРЕНД",
        description: "Теперь все речные и морские круизы можно найти и купить в одном месте – в интернет-магазине \xabКруиз.онлайн\xbb",
        photo: "/images/news/30.jpg",
        media: "Вестник АТОР",
        link: "https://www.atorus.ru/news/press-centre/new/57076.html",
        date: "04.10.2021"
    },
    {
        title: "Компания \xabТвой круиз\xbb объявила о ребрендинге",
        description: "На сайте представлено более 4500 маршрутов по рекам и озерам России, а также 48 морских лайнеров",
        photo: "/images/news/26.jpg",
        media: "Рата Ньюс",
        link: "https://ratanews.ru/news/news_4102021_7.stm",
        date: "04.10.2021"
    },
    {
        title: 'Оборот онлайн-магазина "Твой круиз" в 2021 году достиг 800 млн рублей',
        description: 'Оборот онлайн-магазина круизов "Твой круиз" в 2021 году превысил 800 млн рублей, выручка — 100 млн',
        photo: "/images/news/27.jpg",
        media: "Интерфакс-Туризм",
        link: "https://tourism.interfax.ru/ru/news/articles/81794/",
        date: "04.10.2021"
    },
    {
        title: 'Компания "Твой круиз" объявила о ребрендинге',
        description: 'Подняли объем онлайн-продаж в компании до 75% и объединив "море" и "реку" на одном домене kruiz.online',
        photo: "/images/news/28.jpg",
        media: "ВолгаНьюс",
        link: "https://volga.news/article/593886.html",
        date: "04.10.2021"
    },
    {
        title: "Как избежать мошенничества при бронировании путешествий онлайн",
        description: "Соблюдение простых правил поможет избежать контактов с мошенниками и потери денег",
        photo: "/images/news/29.jpg",
        media: "Российская газета",
        link: "https://rg.ru/2021/10/06/kak-izbezhat-moshennichestva-pri-bronirovanii-puteshestvij-onlajn.html",
        date: "06.10.2021"
    },
    // {
    //   title: 'Губерния. Доброе утро',
    //   description:
    //     'С 39 минуты - о том, что такое кешбек и почему это очень просто помогает сэкономить на отдыхе',
    //   photo: '/images/news/14.jpg',
    //   media: 'Медиахолдинг «СОВА»',
    //   link: 'https://sova.info/programs/utro_gubernii/?id=1633613796&sphrase_id=188455',
    //   date: '07.10.2021',
    // },
    // {
    //   title:
    //     'Самарские предприниматели: чтобы избежать локдауна, мы сами должны принять меры',
    //   description:
    //     'Самарский бизнес должен быть здоровым, чтобы оставаться на плаву. В прямом и переносном смысле',
    //   photo: '/images/news/15.jpg',
    //   media: 'Медиахолдинг «СОВА»',
    //   link: 'https://sova.info/news/samarskie-predprinimateli-chtoby-izbezhat-lokdauna-my-sami-dolzhny-prinyat-mery/?sphrase_id=189200',
    //   date: '10.10.2021',
    // },
    {
        title: "ТОП-10 самых популярных теплоходов России по данным онлайн-продаж за 2021 год",
        description: "Лидером по количеству продаж и по объему выручки через интернет стал четырехпалубный теплоход \xabЛебединое озеро\xbb",
        photo: "/images/news/16.jpg",
        media: "Вести Туризм",
        link: "https://travelvesti.ru/news/top-10-samykh-populyarnykh-teplokhodov-rossii-po-dannym-onlajn-prodazh-za-2021-god.html",
        date: "02.11.2021"
    },
    {
        title: "Туристам в море некаютно. От зарубежных круизов осталось 15%",
        description: "Россиянам доступно только 15% от докризисного объема предложения, при этом рынок восстановился на 50%.",
        photo: "/images/news/18.jpg",
        media: "Коммерсантъ",
        link: "https://www.kommersant.ru/doc/5062109",
        date: "03.11.2021"
    },
    {
        title: "Выплывали как могли: сезон навигации в Петербурге завершился с прибылью",
        description: "Круизная отрасль, ориентированная на международные рейсы, второй год подряд считает убытки.\n",
        photo: "/images/news/17.jpg",
        media: "Деловой Петербург",
        link: "https://www.dp.ru/a/2021/11/02/Viplivali_kak_mogli_zhark11",
        date: "03.11.2021"
    },
    {
        title: "Стали известны цены на круизы в 2022 году",
        description: "Компании открыли продажи круизов на 2022 год. Стоимость путешествий от 33 тысяч рублей на человека.",
        photo: "/images/news/19.jpg",
        media: "Российская газета",
        link: "https://rg.ru/2021/11/05/stali-izvestny-ceny-na-kruizy-v-2022-godu.html",
        date: "05.11.2021"
    },
    {
        title: "Для развития круизов в России придется строить причалы и дороги",
        description: "Для развития круизов нужно углублять реки, строить причалы и подъездные дороги.",
        photo: "/images/news/20.jpg",
        media: "Российская газета",
        link: "https://rg.ru/2021/11/15/dlia-razvitiia-kruizov-v-rossii-pridetsia-stroit-prichaly-i-dorogi.html",
        date: "15.11.2021"
    },
    {
        title: "25 тревел стартапов, за которыми стоит следить в 2022 году",
        description: "Уникальная система бронирования со схем кораблей, электронный документооборот, техническая и сервисная поддержка в трэвел.",
        photo: "/images/news/32.jpg",
        media: "vc.ru",
        link: "https://vc.ru/flood/337865-25-trevel-startapov-za-kotorymi-stoit-sledit-v-2022-godu",
        date: "23.12.2021"
    },
    {
        title: "Лас-Вегас на море: как американец сделал $6,5 млрд на веселых круизах",
        description: "Мики Арисон превратил небольшую компанию своего отца в крупнейший круизный бизнес мира",
        photo: "/images/news/25.jpg",
        media: "РБК",
        link: "https://pro.rbc.ru/news/61cd7d4d9a79476ba6e505d8?utm_source=rbc.ru&utm_medium=inhouse_media&utm_campaign=center&utm_content=61cd7d4d9a79476ba6e505d8&from=column_2",
        date: "01.01.2022"
    },
    {
        title: "Встречайте весну с кэшбэком! Речные круизы с максимальной выгодой до 32%!",
        description: "Морские и речные круизы стали еще доступнее!!! Скидка на раннее бронирование до 12% , вместе с кэшбэком 20%",
        photo: "/images/news/34.jpg",
        media: "bloknot-rostov.ru",
        link: "https://bloknot-rostov.ru/news/vstrechayte-vesnu-s-keshbekom-rechnye-kruizy-s-mak-1441934",
        date: "28.01.2022"
    },
    {
        title: "Эксперты оценили перспективы международных круизов из Сочи",
        description: "Морские и речные круизы стали еще доступнее!!! Скидка на раннее бронирование до 12% , вместе с кэшбэком 20%",
        photo: "/images/news/35.jpg",
        media: "ПрофиТревел",
        link: "https://profi.travel/news/54241/details",
        date: "31.01.2022"
    }, 
].reverse();


/***/ }),

/***/ 75685:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"breadCrumbs_wrapper__GujyW","overflowWrapper":"breadCrumbs_overflowWrapper__O0aFR","point":"breadCrumbs_point___AwGt","current":"breadCrumbs_current__uks0O","currentBf":"breadCrumbs_currentBf__aXcqk","active":"breadCrumbs_active__ExqTi","activeBf":"breadCrumbs_activeBf__8B_QV","crumb":"breadCrumbs_crumb__8cnCn","home":"breadCrumbs_home__ahfAn","homeBf":"breadCrumbs_homeBf__oorFp"};

/***/ })

}]);